class Conditional {
    stateClasses = {
        hidden: 'd-none'
    };

    constructor($el) {
        this.$el = $el;
        this.$target = $(this.$el.data('target'));
        this.value = this.$el.data('value');

        this.init();
    }

    init = () => {
        this.$el.on('change', this.stateHandler);
        this.stateHandler();
    }

    stateHandler = () => {
        if (this.$el.val() == this.value) {
            this.$target.removeClass(this.stateClasses.hidden);
        } else {
            this.$target.addClass(this.stateClasses.hidden);
        }
    }
}

export default Conditional;
